/* wo-map-filters.js — LITE + latest list only + AND + no-result UI (after search, under filters) */
(function () {
  const ROOT = document.querySelector('.wo-home-map');
  if (!ROOT) return;

  // ---- 可視ユーティリティ ----
  function isActuallyHidden(el) {
    if (!el) return true;
    if (el.hidden) return true;
    const cs = getComputedStyle(el);
    return cs.display === 'none' || cs.visibility === 'hidden' || cs.opacity === '0';
  }
  const isVisible = (el) => !isActuallyHidden(el);

  const isHiddenByUs    = (card) => card?.dataset?.woHidden === '1';
  const isHiddenByOmnium= (card) => !card ? true : (!isHiddenByUs(card) && isActuallyHidden(card));

  // ---- ラッパ取得（常に最新） ----
  function getListWrap() {
    const all = Array.from(ROOT.querySelectorAll('.develic-items-wrapper'));
    if (!all.length) return null;
    const visible = all.filter(isVisible);
    return (visible.length ? visible[visible.length - 1] : all[all.length - 1]);
  }

  function getAllCardsInLatestWrap(){
    const wrap = getListWrap();
    if (!wrap) return [];
    return Array.from(wrap.querySelectorAll('.develic-item'));
  }

  // 検索ベース集合（Omniumが表示対象にしているカード）
  function getBaseCards() {
    return getAllCardsInLatestWrap().filter(c => !isHiddenByOmnium(c));
  }

  // 検索欄の値
  function getSearchValue() {
    const inp = ROOT.querySelector('input.develic-search-input[type="search"]');
    return (inp?.value || '').trim();
  }
  const hasQuery = () => getSearchValue().length > 0;

  // フィルター値
  function getActiveValues() {
    return Array.from(ROOT.querySelectorAll('.wo-map-filters input[type="checkbox"]:checked'))
      .map(i => (i.value || '').trim().toUpperCase());
  }
  function getCardTags(card) {
    const el = card.querySelector('.wo-tags');
    if (!el) return '';
    return (el.getAttribute('data-tags') || el.textContent || '').toUpperCase();
  }

  // 自前の表示/非表示（Omniumは上書きしない）
  function hideByFilter(card){ if (!isHiddenByUs(card)) { card.dataset.woHidden='1'; card.style.display='none'; } }
  function showByFilter(card){ if (isHiddenByUs(card)) { delete card.dataset.woHidden; card.style.removeProperty('display'); } }

  // ---- No Result UI ----
  function ensureNoResultEl() {
    let host = ROOT.querySelector('.wo-noresult');
    if (!host) {
      host = document.createElement('div');
      host.className = 'wo-noresult';
      host.innerHTML = `
        <div class="wo-noresult__inner">
          <div class="wo-noresult__msg">該当する店舗がありません</div>
          <button type="button" class="wo-noresult__clear">条件をクリア</button>
        </div>
      `;
      const panel = ROOT.querySelector('.develic-left-panel') || ROOT;
      const filters = panel.querySelector('.wo-map-filters');
      const anchor = filters || panel.firstElementChild || panel;
      anchor.insertAdjacentElement('afterend', host);

      // クリア：フィルターのみ解除（検索語は維持）
      host.querySelector('.wo-noresult__clear').addEventListener('click', () => {
        ROOT.querySelectorAll('.wo-map-filters input[type="checkbox"]:checked')
          .forEach(chk => { chk.checked = false; });
        runFilter();
      });
    } else {
      const panel = ROOT.querySelector('.develic-left-panel') || ROOT;
      const filters = panel.querySelector('.wo-map-filters');
      const anchor = filters || panel.firstElementChild || panel;
      if (host.previousElementSibling !== anchor) {
        anchor.insertAdjacentElement('afterend', host);
      }
    }
    return host;
  }
  function showNoResult() { ensureNoResultEl().classList.add('is-show'); }
  function hideNoResult() { const el = ROOT.querySelector('.wo-noresult'); if (el) el.classList.remove('is-show'); }

  const updateCount = () => { try { window.WO_updateStoreCount && window.WO_updateStoreCount(); } catch (_) {} };

  // ---- 本体 ----
  function runFilter() {
    const active = getActiveValues();
    const base   = getBaseCards();
    const qOn    = hasQuery();
    const fOn    = active.length > 0;

    // ✅ 修正点①：検索なし＆フィルターなしでも、当店側で隠したカードを**全解除**して「ベース（=Omnium表示）に復帰」
    if (!qOn && !fOn) {
      for (const c of getAllCardsInLatestWrap()) showByFilter(c);  // まず自前hideを全解除
      // Omniumが表示にしているもの（=base）は可視、Omniumが非表示のものはそのまま
      hideNoResult();
      updateCount();
      return;
    }

    if (base.length === 0) {
      if (qOn) showNoResult(); else hideNoResult();
      updateCount();
      return;
    }

    hideNoResult();

    if (!fOn) {
      // フィルター未使用：検索結果（ベース）へ復帰
      for (const c of getAllCardsInLatestWrap()) showByFilter(c); // 念のため全解除
      for (const c of base) showByFilter(c);
      hideNoResult();
      updateCount();
      return;
    }

    // フィルターあり：AND絞り
    let visibleCount = 0;
    for (const card of base) {
      const tags = getCardTags(card);
      const ok   = active.every(v => tags.includes(v));
      if (ok) { showByFilter(card); visibleCount++; }
      else { hideByFilter(card); }
    }
    if (visibleCount === 0) showNoResult(); else hideNoResult();
    updateCount();
  }

  // ---- 配線 ----
  let wired = false;
  function wire() {
    if (wired) return;
    wired = true;

    // ✅ 修正点②：通常の CLEAR ボタンも配線
    ROOT.addEventListener('click', (e) => {
      const btn = e.target.closest('.wo-map-filters__clear');
      if (btn) {
        ROOT.querySelectorAll('.wo-map-filters input[type="checkbox"]:checked')
          .forEach(chk => { chk.checked = false; });
        runFilter();
      }
    });

    ROOT.addEventListener('change', (e) => {
      if (e.target && e.target.matches('.wo-map-filters input[type="checkbox"]')) runFilter();
    });

    runFilter();
  }
  wire();

  // 外部からも呼べる
  window.WO_filterWire = wire;
  window.WO_runFilter  = runFilter;

  // ---- 監視 ----
  let mo = null, moTarget = null, moTimer = null;
  function debouncedRun(){ clearTimeout(moTimer); moTimer = setTimeout(runFilter, 120); }
  function observeListWrap() {
    const target = getListWrap();
    if (target === moTarget) return;
    if (mo) { try { mo.disconnect(); } catch (_) {} mo = null; }
    moTarget = target;
    if (!target) return;
    mo = new MutationObserver(debouncedRun);
    mo.observe(target, { childList:true, subtree:true, attributes:true, attributeFilter:['style','class','hidden'] });
  }
  observeListWrap();
  const sentinel = new MutationObserver(observeListWrap);
  sentinel.observe(ROOT, { childList:true, subtree:true });
})();
